import { useQuery } from '@tanstack/react-query';
import { API_CACHE_KEYS, API_PATHS } from '@/modules/common/constants';
import { useEffect } from 'react';
import { useToast } from '@pw-tech/omni-ui';
import { getErrorMessage } from '@/modules/common/utils';
import { ApiClient } from '@pw-tech/web-sdk';
import { useRouter } from 'next/router';

export const useGetExamScheduleDates = ({ enabled = true }: { enabled?: boolean }) => {
  const { toast: showToaster } = useToast();
  const router = useRouter();
  const { courseId } = router.query;

  const { data, error, isFetching, isLoading, refetch } = useQuery<any>({
    queryKey: [API_CACHE_KEYS.GET_EXAM_SCHEDULE_DATES, courseId],
    queryFn: () =>
      ApiClient.get(API_PATHS.GET_EXAM_SCHEDULE_DATES, {
        params: {
          courseId: courseId as string,
        },
      }),
    enabled: enabled && !!courseId,
  });

  useEffect(() => {
    if (error) {
      const errorMessage = getErrorMessage(error, 'Error in fetching exam schedule dates..');
      showToaster({
        message: errorMessage,
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
      });
    }
  }, [error]);

  return {
    data: data || null,
    error,
    isFetching,
    isLoading,
    refetch,
  };
};
